import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { JsonMapperService } from 'src/app/core/services/mapper/mapper.service';
import { Fonction } from '../../models/fonction.model';

@Injectable({
    providedIn: 'root'
})
export class FonctionsService {
    constructor(private readonly http: HttpClient, private readonly mapper: JsonMapperService) {}

    getFonction(idFonction: number): Observable<Fonction> {
        return this.http
            .get<Fonction>(`/api/intervenant/private/fonctions/${idFonction}`)
            .pipe(map(fonction => this.mapper.deserializeObject(fonction, Fonction)));
    }

    public creerFonction(fonction: Fonction): Observable<number> {
        return this.http
            .post('/api/intervenant/private/fonctions', fonction, { observe: 'response' })
            .pipe(map(response => parseInt(response.headers.get('location').split('/').pop(), 10)));
    }

    public modifierFonction(fonction: Fonction): Observable<void> {
        return this.http.put<void>(`/api/intervenant/private/fonctions/${fonction.id}`, fonction);
    }

    public supprimerFonction(idFonction: number): Observable<void> {
        return this.http.delete<void>(`/api/intervenant/private/fonctions/${idFonction}`);
    }
}
